// @ts-check
import React from "react"
import TaskAdminInteractionChip, {
  TASK_ADMIN_INTERACTION_CHIP_TYPE,
} from "../TaskAdminInteractionChip.molecule"
import IconWithTooltip from "../IconWithTooltip.molecule"

/**
 * @param {import("./TaskCell.molecule").TaskCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */
export function TaskCell(props) {
  const { ctx } = props
  const { row, getValue } = ctx
  const task = getValue()

  if (row.getIsGrouped()) return null

  const isEditedByAdmin = row.original?.editedByAdmin
  const isCreatedByAdmin = row.original?.createdByAdmin

  return (
    <div className="w-full flex justify-content-between align-items-center gap-2">
      <span
        className="overflow-hidden white-space-nowrap text-overflow-ellipsis"
        title={task}
      >
        {task}
      </span>
      <div className="flex align-items-center gap-2">
        {isEditedByAdmin || isCreatedByAdmin ?
          <TaskAdminInteractionChip
            state={
              isEditedByAdmin ?
                TASK_ADMIN_INTERACTION_CHIP_TYPE.EDITION
              : TASK_ADMIN_INTERACTION_CHIP_TYPE.CREATION
            }
            name={row.original.adminName + " " + row.original.adminLastName}
          />
        : null}
        {row.original.comment ?
          <IconWithTooltip
            tooltipValue={row.original.comment}
            iconClassName="pi pi-comment"
          />
        : null}
      </div>
    </div>
  )
}
